<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
  </div>
</template>

<script>
  import content from '../../api/content';
  export default {
    data () {
      return {
        info:'',
        name: '汽车时间'
      }
    },
    created () {
      this.$store.commit('param/show', false)
      let source = this.$store.state.param.source
      if(source == 1||source == 2||source == 3||source == 4||source == 7||source == 11) {
        this.name = '汽车时间'
        this.getAgreement(1)
        this.$appService.isShowReturn({state: true})
      } else if(source == 6||source == 8||source == 9) {
        this.name = '凌志范儿'
        this.getAgreement(10)
        this.$appService.isShowReturn({state: true})
      }else if(source == 5) {
        this.name = '富士范儿'
        this.getAgreement(9)
        this.$appService.isShowReturn({state: true})
      }else if(source == 12) {
        this.name = 'VTEC范儿'
        this.getAgreement(14)
        this.$appService.isShowReturn({state: true})
      }
    },
    methods: {
      getAgreement(id){
        content.getAgreement({id:id}).then(res => {
          this.info=res.data.data
        })
      },
    }
  };
</script>

<style lang="scss">
  .agreement_page {
    padding: 10px;    
  }
</style>
